module.exports = __webpack_public_path__ + "img/logo.693c81ab.png";